import { PricingItem, QuoteService } from 'quote-domain-core';
import { PricingItemCorridorService } from '../pricing-item/pricing-item-corridor-service';
import { PricingItemPriceService } from '../pricing-item/pricing-item-price-service';
import { QuoteServiceCorridorAggregationService } from './quote-service-corridor-aggregation-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceDiscountService {
    constructor(
        private readonly corridorAggregationService: QuoteServiceCorridorAggregationService,
        private readonly pricingItemCorridorService: PricingItemCorridorService,
        private readonly pricingItemPriceService: PricingItemPriceService
    ) {
    }

    public applyGlobalDiscount(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.applyServiceGlobalDiscountToPricingItem(pricingItem, quoteService.distance, quoteService.appliedPriceColor);
        });
        const result = this.corridorAggregationService.sumDevicesAndConsumablesAppliedPrices(quoteService);
        this.corridorAggregationService.updateQuoteServiceDiscount(quoteService, result.appliedPriceDevices, result.appliedPriceConsumables);
    }

    public calculateDiscount(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemPriceService.calculateDiscount(pricingItem);
        });
    }

    private forEachPricingItem(quoteService: QuoteService, callback: (pricingItem: PricingItem) => void): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(callback);
        });
    }
}
